import { render, staticRenderFns } from "./WholeCalendarMonth.vue?vue&type=template&id=731c60c3"
import script from "./WholeCalendarMonth.vue?vue&type=script&lang=js"
export * from "./WholeCalendarMonth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports